/* unplugin-vue-components disabled */import script from "./DramaEditCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DramaEditCard.vue?vue&type=script&setup=true&lang=js"

import "./DramaEditCard.vue?vue&type=style&index=0&id=300f9746&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300f9746"]])

export default __exports__